import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f130360a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "app-container__main" }

import { onBeforeMount } from 'vue';
import axios from 'axios';
import { useRouter, useRoute } from 'vue-router';
import { AppHeader } from '@ds/components';
import SidebarNavigation from '@shared/components/SidebarNavigation.vue';
import CreateMerchant from '@shared/components/CreateMerchant.vue';
import { useUserStore } from './store';
import { MerchantDropdown, LandingMessage } from './components';

type ClientCredentials = {
	client_id: string;
	credential: string;
	select_by: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const userStore = useUserStore();

const GLOBAL_PAGES = [
	'bankIntegration',
	'division-requests',
	'kycChecks',
	'payout-request-details',
	'payout-requests',
	'payouts',
	'pspIntegration',
];

let checkExpiredTimeInterval: number;
let checkExpiredJWTToken: number;

const logout = async () => {
	userStore.logoutUser();
	await router.push({ name: 'login' });
};

const updateExpiredTimeHandler = () => {
	if (localStorage.getItem('isUserLoggedIn') === 'true' && userStore.isUserLoggedIn)
		localStorage.setItem('_expiredTime', JSON.stringify(Date.now() + 1.2e6)); // 20min for expiring session
};

const refreshJWT = () => {
	window?.google?.accounts.id.initialize({
		client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
		auto_select: true,
		callback: async (response: ClientCredentials) => {
			axios.defaults.headers.common = { Authorization: `${response.credential}` };
			localStorage.setItem('JWT', response.credential);
		},
	});

	window?.google?.accounts.id.prompt();
	localStorage.setItem('_expiredJWT', JSON.stringify(Date.now() + 3.3e6)); // 3.3e6 55min for auto-refresh session
};

onBeforeMount(() => {
	if (
		!localStorage.getItem('_expiredTime') ||
		parseInt(localStorage.getItem('_expiredTime') || '0', 10) < Date.now() ||
		localStorage.getItem('isUserLoggedIn') === 'false'
	)
		logout();

	const cachedUserInfo = localStorage.getItem('userInfo');
	const cachedJWT = localStorage.getItem('JWT');

	if (cachedUserInfo && cachedJWT) userStore.storeUser(JSON.parse(cachedUserInfo), cachedJWT);

	// Start listeners checking for inactive user
	window.addEventListener('mousemove', updateExpiredTimeHandler);
	window.addEventListener('scroll', updateExpiredTimeHandler);
	window.addEventListener('keydown', updateExpiredTimeHandler);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	checkExpiredTimeInterval = setInterval(() => {
		const userIsLoggedIn =
			localStorage.getItem('isUserLoggedIn') &&
			localStorage.getItem('isUserLoggedIn') === 'true';

		const expiredTime = parseInt(localStorage.getItem('_expiredTime') || '0', 10);
		if (expiredTime < Date.now() && userIsLoggedIn) logout();
	}, 5000);

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	checkExpiredJWTToken = setInterval(() => {
		const userIsLoggedIn =
			localStorage.getItem('isUserLoggedIn') &&
			localStorage.getItem('isUserLoggedIn') === 'true';

		const expiredJWT = parseInt(localStorage.getItem('_expiredJWT') || '0', 10);
		if (expiredJWT < Date.now() && userIsLoggedIn) refreshJWT();
	}, 5000);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(userStore).isUserLoggedIn)
      ? (_openBlock(), _createBlock(SidebarNavigation, {
          key: 0,
          "is-showing-homepage": false
        }))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_2, [
      (_unref(userStore).isUserLoggedIn)
        ? (_openBlock(), _createBlock(_unref(AppHeader), {
            key: 0,
            title: _ctx.$route?.meta?.title as string || '',
            "user-name": _unref(userStore).givenName,
            "user-email": _unref(userStore).email,
            imageUrl: _unref(userStore).picture,
            "logout-label": _ctx.$t('globals.logout'),
            onLogout: logout
          }, {
            default: _withCtx(() => [
              _createVNode(CreateMerchant, { class: "mr-4" }),
              _createVNode(_unref(MerchantDropdown), { class: "mr-4" })
            ]),
            _: 1
          }, 8, ["title", "user-name", "user-email", "imageUrl", "logout-label"]))
        : _createCommentVNode("", true),
      (
					_unref(userStore).isUserLoggedIn &&
					!_unref(route).query?.merchantCode &&
					!GLOBAL_PAGES.includes(_ctx.$route.name?.toString() || '')
				)
        ? (_openBlock(), _createBlock(_unref(LandingMessage), { key: 1 }))
        : (_openBlock(), _createBlock(_component_router_view, { key: 2 }))
    ])
  ]))
}
}

})